import styled from 'styled-components';

export const RewardsCarouselContainer = styled.div`
  margin-top: -0.6rem;

  ${Styles.mobile`
    margin-top: -1rem;
  `}
`;
